export const load = () => ({
	title: 'Insulate and Preserve your Specialty Window with Window Inserts',
	showTitle: true,
});
